<template>
  <svg width="20" height="12" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :d="'M16.6928 3.42846C15.3053 3.52221 13.3258 4.89364 12.3241 5.34364C11.5446 5.69453 10.8723 5.99' +
             '721 10.2857 5.99721C9.6803 5.99721 9.58923 5.56328 9.71512 4.60703C9.74459 4.39274 10.0285 2.4856 8.57' +
             '137 2.56864C7.89905 2.60881 6.84905 3.23292 4.03119 5.94364L5.1428 3.16596C5.95709 1.13292 3.7178 -0.8' +
             '92078 1.66869 0.412387L0.198159 1.40078C-5.54153e-05 1.52667 -0.058984 1.79185 0.0669089 1.99274L0.527' +
             '623 2.71596C0.653516 2.91685 0.918695 2.97578 1.11959 2.84721L2.67316 1.80524C3.16602 1.49185 3.76334 ' +
             '1.9981 3.54905 2.53114L0.918695 9.10971C0.736552 9.56239 0.991016 10.2856 1.71423 10.2856C1.93655 10.2' +
             '856 2.15619 10.1999 2.31959 10.0338C3.44994 8.90346 6.46334 5.99721 7.97673 4.78917C7.9178 5.55256 7.9' +
             '2048 6.36685 8.52852 7.03381C8.93834 7.48381 9.52762 7.71149 10.283 7.71149C11.2366 7.71149 12.1044 7.' +
             '32042 13.0232 6.90792C13.9071 6.51149 15.6749 5.23114 16.7303 5.14542C16.958 5.12667 17.1374 4.94989 1' +
             '7.1374 4.72221V3.86239C17.1428 3.61864 16.9366 3.41239 16.6928 3.42846Z'" fill="#777777"/>
  </svg>
</template>
<script>
export default {
  name:'IconeAssinarDocumento'
}
</script>